<div class="commands">
  <div class="commands__head">
    <h4 class="commands__title m-0">{{ "testing.commands" | translate }}</h4>
    <small class="commands__subtitle">{{ "panel-alerts.commands-help" | translate }}</small>
  </div>

  <div class="commands__list">
    <!-- Comandos regulares -->
    <app-panel-command-button
      *ngFor="let item of regularItems; trackBy: trackByKey"
      [item]="item"
      (run)="onRun($event)"
    ></app-panel-command-button>

    <!-- Card de vaciado -->
    <app-menu-empty
      class="commands__empty"
      [list]="feeders"
      [type]="'feeder'"
      [disabled]="feeders.length === 0"
      [emptyItem]="emptyCommandItem"
      [respondedFeeders]="emptyRespondedFeeders"
      (submitFrameEmpty)="onEmpty($event)"
    ></app-menu-empty>

    <!-- Fila de interruptores: Encender + Apagar -->
    <div class="commands__toggles" *ngIf="toggleItems.length > 0">
      <app-panel-command-button
        *ngFor="let item of toggleItems; trackBy: trackByKey"
        [item]="item"
        (run)="onRun($event)"
      ></app-panel-command-button>
    </div>
  </div>
</div>
